import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import './toast.scss'

const ToastNoti = () => {
  return (
    <>
      <ToastContainer
        className="toast-noti-container"
        position="top-right"
        // autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  )
}
export default ToastNoti
